var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrigin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.291 16c0 2.922-2.369 5.291-5.291 5.291s-5.291-2.369-5.291-5.291c0-2.922 2.369-5.291 5.291-5.291s5.291 2.369 5.291 5.291z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrigin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/origin.39628c29d4c049a1ef44b58ea28dab30.svg";